export function formatAdminDate(value) {
    if (!value)
        return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime()))
        return value.slice(0, 10);
    return date.toLocaleDateString('ru-RU');
}
export function formatAdminDateTime(value) {
    if (!value)
        return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime()))
        return value;
    return date.toLocaleString('ru-RU');
}
export function formatRub(value) {
    if (value == null || !Number.isFinite(value))
        return '—';
    return `${value.toLocaleString('ru-RU')} ₽`;
}
export function yesNo(value) {
    return value ? 'Да' : 'Нет';
}
